import { http } from "./config";
import authHeader from "./auth-header";

export default {
  lista_disparos: (dtinicial, dtfinal, empresa) => {
    const params = {
      "data-inicial": dtinicial,
      "data-final": dtfinal,
      empresa: empresa,
    };
    return http.get("/mensageria-v2/lista-disparos", {
      params: params,
      headers: authHeader(),
    });
  },
  salvar_regrav2: (regra) => {
    return http.post("/mensageria-v2/salvar", regra, {
      headers: authHeader(),
    });
  },
  lista_regrasv2: (tipo) => {
    return http.get(`/mensageria-v2/listar`, {
      headers: authHeader(),
      params: {
        tipo: tipo,
      },
    });
  },
  importar_mensageria_lote: (file, dto) => {
    const form = new FormData();
    form.append("file", file, file.name);

    form.append(
      "dto",
      new Blob([JSON.stringify(dto)], { type: "application/json" }),
      "dto.json",
    );

    return http.post("/mensageria-v2/importar-mensageria-em-lote", form, {
      headers: { ...authHeader() },
      transformRequest: (v) => v,
    });
  },
  listar_mensagerias_em_lote: () => {
    return http.get("/mensageria-v2/mensageria-em-lote", {
      headers: authHeader(),
    });
  },
  buscar_mensageria_em_lote_por_id: (id) => {
    return http.get(`/mensageria-v2/mensageria-em-lote/${id}`, {
      headers: authHeader(),
    });
  },
  buscar_resumo_status_mensageria_em_lote: (id) => {
    return http.get(`/mensageria-v2/mensageria-em-lote/${id}/status-resumo`, {
      headers: authHeader(),
    });
  },
  downloadExcelComposicao: (id) => {
    return http.get(`/mensageria-v2/mensageria-em-lote/${id}/clientes-xls`, {
      headers: authHeader(),
      responseType: "blob",
    });
  },
  atualizar_status_mensageria_em_lote: (id, status) => {
    return http.put(`/mensageria-v2/mensageria-em-lote/${id}/status`, null, {
      headers: authHeader(),
      params: {
        status: status,
      },
    });
  },

  // Criar / atualizar regra
  salvar_mensageria_aniversario: (payload) => {
    return http.post(`/mensageria-aniversario`, payload, {
      headers: authHeader(),
    });
  },

  // Listar regras
  listar_mensageria_aniversario: () => {
    return http.get(`/mensageria-aniversario`, {
      headers: authHeader(),
    });
  },

  // Buscar clientes da regra
  listar_mensageria_aniversario_por_id: (regraId) => {
    return http.get(`/mensageria-aniversario/${regraId}/clientes`, {
      headers: authHeader(),
    });
  },

  // Mensageria Automações
  salvarAutomacao: (payload) => {
    return http.post(`/mensageria-automacao`, payload, {
      headers: authHeader(),
    });
  },

  listarAutomacoes: () => {
    return http.get(`/mensageria-automacao`, {
      headers: authHeader(),
    });
  },

  alterarStatus: (id) => {
    return http.put(`/mensageria-automacao/${id}`, {}, {
      headers: authHeader(),
    });
  },

  listarDadosEnviados: (automacaoId) => {
    return http.get(`/mensageria-automacao/${automacaoId}/dados-enviados`, {
      headers: authHeader(),
    });
  },

  exportarDadosEnviados: (automacaoId) => {
    return http.get(`/mensageria-automacao/${automacaoId}/exportar`, {
      headers: authHeader(),
      responseType: "blob",
    });
  },
};
